<template>
  <EmailDeliveryTable
    fetchAction="EmailDeliveryStore/getHistoryList"
    clearHistoryAction="EmailDeliveryStore/clearHistory"
    placeholder="No email history available."
    :autoRefresh="true"
  />
</template>

<script>
import EmailDeliveryTable from "./EmailDeliveryTable";
export default {
  components: {
    EmailDeliveryTable,
  },
};
</script>
